import React from 'react';
import StyledButton from './styled-button';
import { Modal, ModalCloseButton, ModalContent, ModalTrigger } from './modal';
import StyledLink from './styled-link';
import mostRelevantEinrichtung from '../../utils/most-relevant-einrichtung';

interface AvatarModalProps {
    name?: string
    image?: IWPImage
    job?: string | null
    jobDescription?: string | null
    contact?: {
        email?: string
        fax?: string
        phone?: string
        title?: string
    }[] | null,
    education?: string
    focus?: { focus?: string }[]
    hasSingle?: boolean | null
    link?: string | null
    einrichtung?: null | {
        id: string
        title: string
        acfFields: {
            address: string | null
        }
        slug: string
        types: null | {
            nodes: {
                name: string | null
                slug: string | null
            }[]
        }
    }[]
    children?: React.ReactNode
}

const AvatarModal = ({
    children, name, job, jobDescription, link, contact, focus, einrichtung: allEinrichtung,
    ...props
}: AvatarModalProps): JSX.Element => {
    const einrichtung = mostRelevantEinrichtung(allEinrichtung || null);

    if (!link && !contact && !focus && !einrichtung) {
        return <div css={{ width: '100%' }}>{children}</div>;
    }

    return (
        <Modal>
            <ModalTrigger
                {...props}
            >
                {children}
            </ModalTrigger>
            <ModalContent
                css={{
                    maxWidth: '628px',
                    padding: '0',
                    '@media (max-width: 767px)': {
                        maxWidth: '100%',
                    },
                    borderRadius: 0,
                }}
            >
                <ModalCloseButton
                    css={{
                        marginRight: '-15px',
                        marginTop: '-50px',
                        '& svg *': {
                            stroke: '#ffffff',
                        },
                    }}
                />
                <div
                    css={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'flex-start',
                        flexDirection: 'column',
                        paddingBottom: '10px',
                    }}
                >
                    <div
                        css={{
                            width: '100%',
                            display: 'flex',
                            padding: '35px 44px 21px',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            backgroundColor: 'var(--color-blue-dunkelblau)',
                            '@media (max-width: 767px)': {
                                padding: '35px 20px 21px',
                            },
                        }}
                    >
                        <h2
                            className="h2"
                            css={{
                                color: 'var(--color-gray-hellgrau)',
                                fontFamily: 'Open Sans !important',
                            }}
                        >
                            {name}
                        </h2>
                    </div>
                    <div
                        css={{
                            width: '100%',
                            height: 'auto',
                            display: 'flex',
                            padding: '25px 44px 47px',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            backgroundColor: 'var(--color-gray-white)',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            '@media (max-width: 767px)': {
                                padding: '25px 20px 37px',
                            },
                        }}
                    >
                        <span css={{ marginBottom: '32px' }}>
                            {job && (
                                <p
                                    className="p2"
                                >
                                    <strong dangerouslySetInnerHTML={{ __html: job }} />
                                </p>
                            )}
                            {jobDescription && (
                                <p
                                    className="p2"
                                    dangerouslySetInnerHTML={{ __html: jobDescription }}
                                />
                            )}
                        </span>
                        <div css={{
                            paddingBottom: '20px',
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns: '1fr 2fr',
                            gridGap: '7px 25px',
                            '@media (max-width: 767px)': {
                                gridTemplateColumns: 'auto 1fr',
                            },
                        }}
                        >
                            {contact && contact.map(({ email, phone, title, fax }, index) => (
                                <>
                                    {title && (
                                        <div key={`title_${index}`} css={{ gridColumn: '1 / 3' }}>
                                            <p
                                                className="p1"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',
                                                    fontWeight: '700!important',
                                                    marginTop: '20px',
                                                }}
                                            >
                                                {title}
                                            </p>
                                        </div>
                                    )}
                                    {email && (
                                        <>
                                            <div
                                                key={`mail_label_${index}`}
                                                className="p2"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',
                                                    fontWeight: '700!important',
                                                }}
                                            >
                                                Email:
                                            </div>
                                            <div key={`mail_${index}`}>
                                                <StyledLink
                                                    small
                                                    to={`mailto:${email}`}
                                                    className="p2"
                                                    css={{
                                                        color: 'var(--color-gray-schwarz)',
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {email}
                                                </StyledLink>
                                            </div>
                                        </>
                                    )}

                                    { phone && (
                                        <>
                                            <div
                                                key={`phone_label_${index}`}
                                                className="p2"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',
                                                    fontWeight: '700!important',

                                                }}
                                            >
                                                Tel.:
                                            </div>
                                            <div
                                                key={`phone_${index}`}
                                                className="p2"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',
                                                }}
                                            >
                                                {phone}
                                            </div>
                                        </>
                                    )}

                                    {fax && (
                                        <>
                                            <div
                                                key={`fax_label_${index}`}
                                                className="p2"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',

                                                    fontWeight: '700!important',

                                                }}
                                            >
                                                Fax:
                                            </div>
                                            <div
                                                key={`fax_${index}`}
                                                className="p2"
                                                css={{
                                                    color: 'var(--color-gray-schwarz)',
                                                }}
                                            >
                                                {fax}
                                            </div>
                                        </>
                                    )}

                                </>
                            ))}

                            {einrichtung?.acfFields?.address && (
                                <>
                                    <span
                                        className="p2"
                                        css={{
                                            color: 'var(--color-gray-schwarz)',
                                            fontWeight: '700!important',
                                        }}
                                    >
                                        Adresse:
                                    </span>
                                    <span
                                        className="p2"
                                        css={{
                                            color: 'rgb(56, 63, 66)',
                                        }}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: einrichtung?.acfFields?.address }} />
                                    </span>
                                </>
                            )}

                            {focus && focus.length > 0 && focus[0].focus !== null && focus[0].focus !== '' && (
                                <>
                                    <span
                                        className="p2"
                                        css={{
                                            color: 'var(--color-gray-schwarz)',
                                            minWidth: '144px',
                                            fontWeight: '700!important',
                                            marginRight: '25px',
                                        }}
                                    >
                                        Schwerpunkte:
                                    </span>
                                    <span
                                        className="p2"
                                        css={{
                                            color: 'rgb(56, 63, 66)',
                                        }}
                                    >
                                        {focus?.map(({ focus }) => focus).filter(x => !!x).join(', ')}
                                    </span>
                                </>
                            )}
                            {link && (
                                <div
                                    css={{
                                        gridColumn: '1 / 3',
                                        width: '100%',
                                        display: 'flex',
                                        borderTop: '1px solid #e2e2e2',
                                        alignItems: 'flex-start',
                                        paddingTop: '24px',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <StyledButton to={link} arrowRight theme="primary">
                                        Details
                                    </StyledButton>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default AvatarModal;
